import { LabMDM } from "./lab";
import { ManufacturerPatterns } from "./manufacturerPatterns";

export class Manufacturers {
     _id: string;
     manufacturerName: string;
     active: boolean;
     lab: LabMDM;
     machineType: string;
     manufacturerConfigList: ManufacturerPatterns[];
     creationDate: Date;
     version: number;
}